import { combineReducers } from 'redux';
import { reducer as reduxFormReducer } from 'redux-form';
import accounts from './accounts';
import agents from './agents';
import sectors from './sectors';
import forms from './forms';
import root from './root';
import projects from './projects';
import reports from './reports';
import tasks from './tasks';
import taskForms from './task-forms';
import submissions from './submissions';

export default combineReducers({
  accounts,
  agents,
  sectors,
  forms,
  root,
  projects,
  reports,
  tasks,
  taskForms,
  submissions,
  form: reduxFormReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js